import { Link } from "react-router-dom";
import { PageHeader, useSeo } from "@/components/site/Motion";

export default function NotFound() {
  useSeo("Page not found");
  return (
    <div data-testid="not-found-page">
      <PageHeader eyebrow="404" title="This page has gone out of print." intro="The page you requested could not be found." />
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 pb-28">
        <Link to="/" className="inline-flex items-center h-12 px-6 rounded-full bg-[var(--emerald)] text-[var(--paper)]" data-testid="not-found-home">Back to Motive Press</Link>
      </div>
    </div>
  );
}
